<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-12-13 14:40:20
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-05 16:36:02
 * @FilePath: /chaoyongtuan/src/components/business/sampleFreeBroadcastDrawer/components/chooseCooPartner/tableCell/drInfoCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<!-- 达人信息组件 -->
	<div class="drInfoCell">
		<yx-avatar :src="row.head"></yx-avatar>
		<div class="right ml-10">
			<p class="yx-color-text-primary font-h4-regular">
				<platform-icon style="flex-shrink: 0" :platformId="row.platformId" />
				{{ row.anchor_name }}
			</p>
			<p class="yx-color-text-secondary font-h6-regular">
				<span>{{ row.platformId | formatPlatformName('suf') }}：</span>
				<span class="mr-4">{{ anchorAccount }}</span>
			</p>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	name: 'drInfoCell',
	mixins: [mixin],
	data() {
		return {};
	},
	computed: {
		anchorAccount() {
			const temPF = {
				[dataMap.PLATFORM_DY.value]: this.row.anchor_account,
				[dataMap.PLATFORM_KS.value]: this.row.anchor_account,
				[dataMap.PLATFORM_SP.value]: this.row.anchor_uid,
			};
			return temPF[this.row.platformId];
		},
	},
	components: {},
};
</script>
<style lang="less" scoped>
.drInfoCell {
	display: flex;
	align-items: center;
}
</style>
